import React, {useRef, useState} from "react";
import {DndProvider} from "react-dnd";
import MouseBackEnd from "react-dnd-mouse-backend";
import BookingCalendar from "./booking_calendar";
import AvailableBookings from "./available_bookings";
import {useSelector} from "react-redux";
import SelectedBooking from "./selected_booking";

const MeetingsManager = () => {
  const calendarRef = useRef()
  const eventsUrl = useSelector(state => state.meeting_calendar?.events_url)
  const moveEventUrl = useSelector(state => state.meeting_calendar?.move_event_url)
  const [selectedBooking, setSelectedBooking] = useState()
  const [editable, setEditable] = useState(true)

  const handleBookingSelected = (booking) => {
    setSelectedBooking(booking)
  }

  return <DndProvider backend={MouseBackEnd}>
    <div className="col-12">
      <div className="row">
        <div className="col-9">
          <div className="m2 shadow">
            <AvailableBookings/>
          </div>
          <div className="m2 mt-0 shadow">
            <style>
              {`
                .editing-overlay {
                  position: absolute;
                  display: flex;
                  width: 100%;
                  height: 100%;
                  background: #ffffffa3;
                  z-index: 09999;
                  justify-content: center;
                  align-items: center;
                }
              `}
            </style>
            {!editable && <div className="editing-overlay">
              <div className={"text-center"}>
                <i className="fa fa-spinner fa-spin"/>
                <br/>
                Updating ...
              </div>
            </div>}
            <div className="m-4">
              <BookingCalendar
                editable={editable}
                setEditable={setEditable}
                ref={calendarRef}
                eventsUrl={eventsUrl}
                moveEventUrl={moveEventUrl}
                onBookingSelected={handleBookingSelected}
              />
            </div>
          </div>
        </div>
        <div className="col-3">
          {selectedBooking && <div className="m2 shadow">
            <SelectedBooking
              editable={editable}
              setEditable={setEditable}
              setSelectedBooking={setSelectedBooking}
              calendarRef={calendarRef}
              booking={selectedBooking}
            />
          </div>}
        </div>
      </div>
    </div>
  </DndProvider>
}

export default MeetingsManager